class SmsSenderCheck {
  constructor(id, interval = 60000) {
    this.interval = interval; // 默认间隔为60秒
    this.id = id;
    this.lastSentTime = this.getLastSentTimeFromStorage(id); // 从本地存储中获取上次发送时间
  }

  /**
   * 获取上次发送时间
   * @returns {number} - 上次发送时间戳
   */
  getLastSentTimeFromStorage() {
    return parseInt(localStorage.getItem(this.id + "lastSentTime"), 10) || 0;
  }

  /**
   * 保存上次发送时间
   * @param {number} time - 当前时间戳
   */
  saveLastSentTimeToStorage(time) {
    localStorage.setItem(this.id + "lastSentTime", time);
  }

  /**
   * 发送短信
   * @param {string} phoneNumber - 手机号码
   * @param {string} message - 短信内容
   * @returns {Promise<boolean>} - 发送成功返回true，失败返回false
   */
  async check(fn) {
    let   currentTime = Date.now();
    let   lastSentTime = this.getLastSentTimeFromStorage();
    if (currentTime - lastSentTime < this.interval) {
      console.warn("短信发送频率过快，请稍后再试。");
      fn && fn(false, () => {});
      return;
    }

    fn &&
      fn(true, () => {
        this.saveLastSentTimeToStorage(currentTime);
      });
    return true;
  }
}

// 使用示例
export default SmsSenderCheck;

// smsSender.sendSms("12345678901", "您的验证码是123456").then((success) => {
//   if (success) {
//     console.log("短信发送成功");
//   } else {
//     console.log("短信发送失败");
//   }
// });

// // 尝试在60秒内再次发送
// setTimeout(() => {
//   smsSender.sendSms("12345678901", "您的验证码是654321").then((success) => {
//     if (success) {
//       console.log("短信发送成功");
//     } else {
//       console.log("短信发送失败");
//     }
//   });
// }, 5000); // 5秒后尝试再次发送
